var render, staticRenderFns
import script from "./TextHighlight.vue?vue&type=script&lang=js&"
export * from "./TextHighlight.vue?vue&type=script&lang=js&"
import style0 from "./TextHighlight.vue?vue&type=style&index=0&id=3cd16d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd16d48",
  null
  
)

export default component.exports